import { postsCollection } from '../firebaseConfig'

export const getAllPostsMixin = {
  methods: {
    getAllPosts () {
      this.performingRequest = true
      const posts = []

      postsCollection
        .where('published', '==', true)
        .orderBy('createdOn', 'desc')
        .limit(this.maxResults || 25)
        .get()
        .then(docs => {
          docs.forEach(doc => {
            posts.push(doc.data())
          })
          this.performingRequest = false
        })
        .catch(error => {
          console.error(error)
          this.performingRequest = false
        })

      return posts
    }

  }
}

export const getPostsFromAuthorMixin = {
  methods: {
    getPostsFromAuthor (authorId) {
      this.performingRequest = true
      if (!authorId) return false

      const posts = []

      postsCollection
        .where('userId', '==', this.authorId)
        .where('published', '==', true)
        .orderBy('createdOn', 'desc')
        .limit(this.maxResults || 25)
        .get()
        .then(docs => {
          docs.forEach(doc => {
            posts.push(doc.data())
          })
          this.performingRequest = false
        })
        .catch(error => {
          console.error(error)
          this.performingRequest = false
        })

      return posts
    }
  }
}
